document.addEventListener("DOMContentLoaded", function() {
    let selectCountryElements = document.querySelectorAll(".select-country");

    selectCountryElements.forEach(function(element) {
        element.addEventListener("click", function() {
            let dropdown = this.nextElementSibling;
            if (dropdown && dropdown.classList.contains("country-dropdown")) {
                dropdown.style.display = dropdown.style.display === "none" || dropdown.style.display === "" ? "block" : "none";
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function() {
    const accordionItems = document.querySelectorAll('.accordion-item');

    accordionItems.forEach(item => {
        const accordionButton = item.querySelector('.accordion-button');
        accordionButton.addEventListener('click', function() {
            const openItem = document.querySelector('.accordion-item.active');

            if (openItem && openItem !== item) {
                openItem.classList.remove('active');
            }

            item.classList.toggle('active');
        });
    });
});

//find a store

const $storesJson = $('.stores-json');
const $storesWrapper = $('.product-accordion-wrapper');

function sliseArrays(arr, subarr, maxLength) {
    for (let i = 0; i < Math.ceil(arr.length / maxLength); i++){
        subarr[i] = arr.slice((i * maxLength), (i * maxLength) + maxLength);
    }

}

function storesHtml() {
    const json = JSON.parse($storesJson.html());
    const countries = json.countries;
    const stores = json.storesList;
    console.log(json);

    let countriesRowMaxLength;

    let storesGroup = [];

    let htmlButtonsArr = [];
    let htmlButtonsSubArray = [];

    let htmlBodiesArr = [];
    let htmlBodiesSubArray = [];


    //media
    if (window.innerWidth > 1100) {
        countriesRowMaxLength = 4;
    } else if (window.innerWidth > 768) {
        countriesRowMaxLength = 3;
    } else if (window.innerWidth > 575) {
        countriesRowMaxLength = 2;
    } else {
        countriesRowMaxLength = 1;
    }

    //push each country markup to own wrapper
    $.each(countries, (index, country) => {
        const countrySelector = country.selector;
        const title = country.name;
        const image = country.flag;
        let data = {
            country: countrySelector,
            stores: []
        };

        const countryButtonHtml =
            '<div class="product-single__accordion" data-country="'+ countrySelector +'">\n' +
            '<div>\n' +
            '<div class="product-accordion-title-wrap">\n' +
            '<img\n' +
            'src="'+ image +'"\n' +
            'width="32"\n' +
            'height="30"\n' +
            'alt="flag">\n' +
            '<div class="product-single__accordion-title">'+ title +'<span class="country-count" data-stores-total="" data-country="'+ countrySelector +'"></span>'+'</div>\n' +
            '</div>\n' +
            '<i>\n' +
            '<svg\n' +
            'width="12"\n' +
            'height="14"\n' +
            'viewBox="0 0 12 14"\n' +
            'fill="none"\n' +
            'xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M1.44 7.152L5.784 11.328L5.784 0.479999L6.744 0.479999L6.744 11.328L11.112 7.152L11.76 7.848L6.264 13.128L0.768 7.848L1.44 7.152Z" fill="#4B4B4B" />\n' +
            '</svg>\n' +
            '</i>\n' +
            '</div>\n' +
            '</div>\n';


        const htmlBodyTab = `<div
            class="product-single__accordion-text"
            data-country="${countrySelector}"><h2>${countrySelector}</h2></div>`

        htmlBodiesArr.push(htmlBodyTab)

        htmlButtonsArr.push(countryButtonHtml);


        //push each store to own group
        $.each(stores, (index, store) => {
            const storeSelector = store.selector;
            const storeImage = store.img_path;
            const storeName = store.name;
            const storeUrl = store.link;
            const finalUrl = storeUrl.replace(/^https?:\/\//, '').replace(/^www\./, '');
            const formattedUrl = 'www.' + finalUrl;
            if (storeSelector === countrySelector) {
                const storeData = {
                    image: storeImage,
                    name: storeName,
                    url: storeUrl,
                    formattedUrl: formattedUrl,
                    storeSelector: storeSelector
                }

                data.stores.push(storeData)
            }
        })

        storesGroup.push(data)

    });

    console.log(storesGroup);

    //group countires and tabs content
    sliseArrays(htmlButtonsArr, htmlButtonsSubArray, countriesRowMaxLength);
    sliseArrays(htmlBodiesArr, htmlBodiesSubArray, countriesRowMaxLength);

    //display markup wrappers
    for (let i = 0; i < Math.ceil(htmlButtonsArr.length / countriesRowMaxLength); i++){

        //headers wrapper
        $storesWrapper.append('<div class="product-accordion-wrapper-row"></div>');

    }

    //bodies wrapper
    $('.product-accordion-wrapper-row').after('<div class="product-accordion-content-row"></div>');

    //display markup counties headers
    $('.product-accordion-wrapper-row').each((index, row) => {

        $.each(htmlButtonsSubArray, (arrIndex, arr) => {

            if ( arrIndex === index ) {
                $(row).html(arr);
            }

        })

    });

    //display markup countries bodies
    $('.product-accordion-content-row').each((index, row) => {

        $.each(htmlBodiesSubArray, (arrIndex, arr) => {

            if ( arrIndex === index ) {
                $(row).html(arr);
            }

        })


    });


    //display stores markup
    $('.product-single__accordion-text').each((index, accordion) => {

        const accordionCountry = $(accordion).attr('data-country');

        $.each(storesGroup, (index, group) => {
            if ( group.country === accordionCountry ) {

                const storesData = group.stores

                if ( storesData.length > 0 ) {
                    $.each(storesData, (index, store) => {

                        const html = `
                          <div class="product-single__accordion-item" data-country-name="${store.storeSelector}" data-store-name="${store.name}">
                            <div class="product-single__accordion-item--img">
                            <a href="${store.url}" target="_blank" rel="noopener noreferrer">
                              <img src="${store.image}" />
                            </a>
                            </div>
                          </div>
                        `;


                        $(accordion).append(html);
                    })
                } else {
                    $(accordion).append('<div><p>There is no available stores in your country</p></div>')
                }

            }
        })

    });

    $('.country-count').each((index, count) => {
        const countDataCountry = $(count).attr('data-country');
        const accordions = $('.product-single__accordion-text');

        accordions.each((index, accordion) => {
            const accordionBodyDataCountry = $(accordion).attr('data-country');

            if ( countDataCountry === accordionBodyDataCountry ) {
                $(count).text('(' + $(accordion).find('.product-single__accordion-item').length + ')')
            }

        })


    })

}

if ($storesJson.length) {

    storesHtml();

    $(document).on('click', '.product-single__accordion', function() {
        const tabsBodies = $('.product-single__accordion-text');

        const activeTab = $('.product-single__accordion.active');

        // If we're on mobile (screen width <= 575px), close all other accordions except the clicked one
        if (window.innerWidth <= 575) {
            $('.product-single__accordion').not(this).removeClass('active'); // Remove 'active' from other accordions
            tabsBodies.not($(this).next()).hide(400); // Hide the content of other accordions
        }

        $(this).toggleClass('active'); // Toggle the 'active' class on the clicked accordion


        tabsBodies.each((index, body) => {

            if ( $(body).attr('data-country') === $(this).attr('data-country')) {

                if ( $(this).hasClass('active') ) {
                    $(body).show(400)


                } else {
                    $(body).hide(400)
                }

            } else {
                if ( window.innerWidth > 575 ) {
                    $(body).hide(400)
                }
            }

        });

    });

}

document.addEventListener('DOMContentLoaded', function() {
    const accordionItems = document.querySelectorAll('.accordion-item');

    accordionItems.forEach(item => {
        const accordionButton = item.querySelector('.accordion-button');
        accordionButton.addEventListener('click', function() {
            const openItem = document.querySelector('.accordion-item.active');

            if (openItem && openItem !== item) {
                openItem.classList.remove('active');
            }

            item.classList.toggle('active');
        });
    });

    // Add search functionality
    const searchInput = document.getElementById('country-search');
    const accordionWrapperRows = document.querySelectorAll('.product-accordion-wrapper-row');
    const accordionItemsText = document.querySelectorAll('.product-single__accordion');
    const accordionItemsContent = document.querySelectorAll('.product-single__accordion-text');
    const noCountriesMessage = document.getElementById('no-countries-message');

    const accordionStoresItems = document.querySelectorAll('.product-single__accordion-item');


    searchInput.addEventListener('input', function() {
        const searchValue = this.value.toLowerCase();
        let anyCountryVisible = false; // Track if any country is visible

        accordionItemsContent.forEach(item => {
            item.style.display = 'none';
        })

        accordionItemsText.forEach(item => {
            item.classList.remove('active');
        })

        // Iterate through each accordion to check country name
        accordionItemsText.forEach(function(item) {
            const countryTitle = item.querySelector('.product-single__accordion-title').textContent.toLowerCase();

            // If country name starts with the search value, show it; otherwise, hide it
            if (countryTitle.startsWith(searchValue)) {
                item.style.display = 'block';
                anyCountryVisible = true; // At least one country is visible
            } else {
                item.style.display = 'none';
            }
        });

        accordionStoresItems.forEach(item => {
            const storeName = item.getAttribute('data-store-name').toLowerCase();
            const storeCountry = item.getAttribute('data-country-name');
            
            if (storeName.startsWith(searchValue)) {
                document.querySelector(`.product-single__accordion[data-country="${storeCountry}"]`).style.display = 'block';
                anyCountryVisible = true;

                const firstVisibleAccordion = document.querySelector('.product-single__accordion[style="display: block;"]');

                if (firstVisibleAccordion && searchValue.length > 0) {
                    const firstAccordionCountry = firstVisibleAccordion.getAttribute('data-country');

                    const visibleAccordionTrigger = [...accordionItemsText].find(item => item.getAttribute('data-country') === firstAccordionCountry);
                    visibleAccordionTrigger.classList.add('active');

                    const visibleAccordionContent = [...accordionItemsContent].find(item => item.getAttribute('data-country') === firstAccordionCountry);
                    visibleAccordionContent.style.display = 'block';
                }
            } else {
            }
        })

        // After filtering, check each row and hide it if all children (countries) are hidden
        accordionWrapperRows.forEach(function(row) {
            const visibleCountries = row.querySelectorAll('.product-single__accordion:not([style*="display: none"])');

            if (visibleCountries.length === 0) {
                row.classList.add('hidden');
            } else {
                row.classList.remove('hidden');
            }
        });

        // Display the "no countries" message if no countries are visible
        if (!anyCountryVisible) {
            noCountriesMessage.style.display = 'block';
        } else {
            noCountriesMessage.style.display = 'none';
        }
    });
});


